import { HttpAxios } from "@/common/services/httpAxios";
import {
  IAudience,
  ITemplate,
  IWorkflow,
  IEditCampaign,
  ICreateAudience,
  ICreateCampaign,
  ISendCampaignTest,
  ICampaignPunctual,
  ITemplatePunctual,
  IAudiencePunctual,
  ICampaignEmailList,
  ICampaignPunctualList,
  ITemplateWhatsappRequest,
  IDetailsPunctualCampaign,
  ICampaignEmailAdvancedConfigs,
  ITestCampaignPunctual,
  IEditCampaignPunctual,
  ITemplateWhatsappStudio,
  ITemplateListWhatsappStudio,
  ITags,
  ICampaignWhatsapp,
  IConversationConfiguredWhatsapp,
  IDefaultTemplateWhatsapp,
} from "./interfacesCampaigns";
import { IAccount } from "@/common/services/cas/interfacesCas";

//dxpAccountId conta WakeStore
const account: IAccount = JSON.parse(localStorage.getItem("ACCOUNT") || "{}");
const activeMock =
  account?.account === process.env.VUE_APP_ACCOUNT_ID_WAKE_STORE;

const axiosSelected = {
  sents: {
    bffName: activeMock ? "mock" : "bffMailSender",
    path: activeMock
      ? "/selected-customer/campaign-email/sents.json"
      : "/campaign/sents",
    method: activeMock ? "get" : "post",
  },

  drafts: {
    bffName: activeMock ? "mock" : "bffMailSender",
    path: activeMock
      ? "/selected-customer/campaign-email/drafts.json"
      : "/campaign/drafts",
    method: activeMock ? "get" : "post",
  },

  processing: {
    bffName: activeMock ? "mock" : "bffMailSender",
    path: activeMock
      ? "/selected-customer/campaign-email/processing.json"
      : "/campaign/processing",
    method: activeMock ? "get" : "post",
  },

  details: {
    bffName: activeMock ? "mock" : "bffMailSender",
    path: activeMock ? "/selected-customer/campaign-email/details.json" : "",
    method: activeMock ? "get" : "get",
  },

  bounce: {
    bffName: activeMock ? "mock" : "bffMailSender",
    path: activeMock ? "/selected-customer/campaign-email/bounces.json" : "",
    method: activeMock ? "get" : "get",
  },

  config: {
    bffName: activeMock ? "mock" : "bffMailSender",
    path: activeMock
      ? "/selected-customer/campaign-email/config.json"
      : "/campaign/config",
    method: activeMock ? "get" : "get",
  },
};

const axiosSelectedWhatsapp = {
  sents: {
    bffName: activeMock ? "mock" : "bffSysops",
    path: activeMock ? "/whatsapp/pontual/sents.json" : "",
    method: activeMock ? "get" : "get",
  },

  drafts: {
    bffName: activeMock ? "mock" : "bffSysops",
    path: activeMock ? "/whatsapp/pontual/drafts.json" : "",
    method: activeMock ? "get" : "get",
  },

  scheduled: {
    bffName: activeMock ? "mock" : "bffSysops",
    path: activeMock ? "whatsapp/pontual/scheduled.json" : "",
    method: activeMock ? "get" : "get",
  },

  details: {
    bffName: activeMock ? "mock" : "bffSysops",
    path: activeMock ? "whatsapp/pontual/details.json" : "",
    method: activeMock ? "get" : "get",
  },

  defaultPontual: {
    bffName: activeMock ? "mock" : "bffSysops",
    path: activeMock ? "whatsapp/pontual/templates/default.json" : "",
    method: activeMock ? "get" : "get",
  },

  personalizedPontual: {
    bffName: activeMock ? "mock" : "bffSysops",
    path: activeMock ? "whatsapp/pontual/templates/personalized.json" : "",
    method: activeMock ? "get" : "get",
  },

  studio: {
    bffName: activeMock ? "mock" : "bffSysops",
    path: activeMock ? "whatsapp/studio/templates.json" : "",
    method: activeMock ? "get" : "get",
  },

  create: {
    bffName: activeMock ? "mock" : "bffSysops",
    path: activeMock ? "whatsapp/create.json" : "",
    method: activeMock ? "get" : "post",
  },

  updateDraft: {
    bffName: activeMock ? "mock" : "bffSysops",
    path: activeMock ? "whatsapp/create.json" : "",
    method: activeMock ? "get" : "put",
  },

  bemaxCampaign: {
    bffName: activeMock ? "mock" : "bffSysops",
    path: activeMock ? "whatsapp/bemax/campaign.json" : "/Campaign",
    method: activeMock ? "get" : "get",
  },

  bemaxTemplatesDefault: {
    bffName: activeMock ? "mock" : "bffSysops",
    method: activeMock ? "get" : "get",
    path: {
      AbandonCart: activeMock
        ? "whatsapp/bemax/templates/default/abandonCart.json"
        : "",
      AfterSales: activeMock
        ? "whatsapp/bemax/templates/default/afterSales.json"
        : "",
      Frequency: activeMock
        ? "whatsapp/bemax/templates/default/frequency.json"
        : "",
      Welcome: activeMock
        ? "whatsapp/bemax/templates/default/welcome.json"
        : "",
    },
  },

  bemaxTemplatesPersonalized: {
    bffName: activeMock ? "mock" : "bffSysops",
    path: activeMock
      ? "whatsapp/bemax/templates/personalized/personalized.json"
      : "",
    method: activeMock ? "get" : "get",
  },

  selectedTemplate: {
    bffName: activeMock ? "mock" : "bffSysops",
    path: activeMock ? "whatsapp/bemax/selectedTemplate.json" : "",
    method: activeMock ? "get" : "get",
  },
};

/**
 * @description service do módulo de Campanhas
 * @see https://mailsender-bff-experiences.allin.com.br/docs/index.html
 */
class Campaigns {
  async getAudiencesMock(): Promise<IAudience[]> {
    try {
      const response = await HttpAxios.mock("/audience/audiences-list.json");
      const audiences: IAudience[] = response.data.result;

      return audiences;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getAudiences(): Promise<IAudience[]> {
    try {
      const response = await HttpAxios.bffMailSender.get("/campaign/audiences");
      const audiences: IAudience[] = response.data.result;

      return audiences;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getAudience(id: string): Promise<IAudience> {
    try {
      const response = await HttpAxios.bffC.get(
        `/CustomAudience/audience/${id}`
      );

      const audience: IAudience = {
        audienceId: response.data.response.audience[0].audienceId,
        name: response.data.response.audience[0].name,
        emails: response.data.response.audience[0].details?.email.total,
        listId: response.data.response.audience[0].listId,
        status: response.data.response.audience[0].status,
      };

      return audience;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getTemplates(data?: any): Promise<ITemplate[]> {
    try {
      const response = await HttpAxios.bffMailSender.post("/template/filter", {
        data,
      });

      return response.data.result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getDnsConfig(email: string): Promise<any> {
    try {
      const response = await HttpAxios.bffMailSender.get(
        `email/campaign/dnsCheck?providerEmail=${email}`
      );

      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getTemplate(id: any): Promise<ITemplate> {
    try {
      const response = await HttpAxios.bffMailSender.get(`/template/${id}`);

      return response.data.result[0];
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async createCampaign(campaign: ICreateAudience): Promise<ICreateCampaign> {
    try {
      const response = await HttpAxios.bffMailSender.post(
        "/campaign",
        campaign
      );

      return response.data.result[0];
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async sendCampaignTest(
    campaignId: string,
    payload: string[]
  ): Promise<ISendCampaignTest> {
    try {
      const response = await HttpAxios.bffMailSender.post(
        `/campaign/send-test?id=${campaignId}`,
        {
          emails: payload,
        }
      );

      return response.data.result[0];
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async scheduleCampaign(campaignId: string): Promise<any> {
    try {
      const response = await HttpAxios.bffMailSender.patch(
        `/campaign/${campaignId}/schedule`
      );

      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getSentsEmailCampaigns(dateRange: any): Promise<ICampaignEmailList[]> {
    try {
      const response = await HttpAxios[axiosSelected.sents.bffName][
        axiosSelected.sents.method
      ](axiosSelected.sents.path, {
        date: dateRange,
      });

      return response.data.result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getBounceList(id: any): Promise<any> {
    try {
      const URI = activeMock
        ? "/selected-customer/campaign-email/bounces.json"
        : `/campaign/${id}/bounced`;

      const response = await HttpAxios[axiosSelected.bounce.bffName][
        axiosSelected.bounce.method
      ](URI);

      return response.data.result.bounces;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getDraftsEmailCampaigns(dateRange: any): Promise<any> {
    try {
      const response = await HttpAxios[axiosSelected.drafts.bffName][
        axiosSelected.drafts.method
      ](axiosSelected.drafts.path, {
        date: dateRange,
      });

      return response.data.result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getScheduledsEmailCampaigns(): Promise<any> {
    try {
      const response = await HttpAxios[axiosSelected.processing.bffName][
        axiosSelected.processing.method
      ](axiosSelected.processing.path);

      return response.data.result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getDetailsEmailCampaigns(id: string): Promise<any> {
    try {
      const URI = activeMock
        ? "/selected-customer/campaign-email/details.json"
        : `/campaign/${id}/report`;

      const response = await HttpAxios[axiosSelected.details.bffName][
        axiosSelected.details.method
      ](URI);

      return response.data.result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async copyCampaign(id: string): Promise<any> {
    try {
      const response = await HttpAxios.bffMailSender.post(
        `/campaign/${id}/copy`
      );

      return response.data.result[0];
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async deleteEmailCampaign(id: string): Promise<string> {
    try {
      const response = await HttpAxios.bffMailSender.delete(`/campaign/${id}`);

      return response.data.result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async pauseEmailCampaign(id: string): Promise<string> {
    try {
      const response = await HttpAxios.bffMailSender.patch(
        `/campaign/${id}/pause`
      );

      return response.data.result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async unpauseEmailCampaign(id: string): Promise<string> {
    try {
      const response = await HttpAxios.bffMailSender.patch(
        `/campaign/${id}/unpause`
      );

      return response.data.result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async finishEmailCampaign(id: string): Promise<string> {
    try {
      const response = await HttpAxios.bffMailSender.patch(
        `/campaign/${id}/end`
      );

      return response.data.result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async createTemplateEmailCampaign(name: string): Promise<any> {
    try {
      const response = await HttpAxios.bffMailSender.post(`/template`, {
        name: name,
      });

      return response.data.result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async editCampaign(
    id: any,
    campaign: ICreateAudience
  ): Promise<IEditCampaign> {
    try {
      const response = await HttpAxios.bffMailSender.put(
        `/campaign/${id}`,
        campaign
      );

      return response.data.result[0];
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getEmailDataCampaignToEdit(id: string | string[]): Promise<any> {
    try {
      const response = await HttpAxios.bffMailSender.get(`/campaign/${id}`);

      return response.data.result[0];
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getAdvancedConfigs(): Promise<ICampaignEmailAdvancedConfigs> {
    try {
      const response = await HttpAxios[axiosSelected.config.bffName][
        axiosSelected.config.method
      ](axiosSelected.config.path, { timeout: 60000 });

      return response.data.result[0];
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getWhatsappCampaigns(): Promise<ICampaignWhatsapp> {
    try {
      const response = await HttpAxios[
        axiosSelectedWhatsapp.bemaxCampaign.bffName
      ][axiosSelectedWhatsapp.bemaxCampaign.method](
        axiosSelectedWhatsapp.bemaxCampaign.path
      );

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async toggleWhatsappCampaign(payload: any): Promise<any> {
    try {
      const response = await HttpAxios.bffSysops.post(
        "/Campaign/enable-disable",
        payload
      );

      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async hasWhatsappCampaign(): Promise<string> {
    try {
      const response = await HttpAxios.bffSysops.get("/Whatsapp/waba", {
        timeout: 60000,
      });

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getWhatsappTemplateCampaign(
    phoneId: string,
    channelId: string
  ): Promise<ITemplateWhatsappRequest> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.selectedTemplate.path
        : `/template/${phoneId}/${channelId}`;

      const response = await HttpAxios[
        axiosSelectedWhatsapp.selectedTemplate.bffName
      ][axiosSelectedWhatsapp.selectedTemplate.method](URI);

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async changeWhatappCampaign(channelId: string, payload: any) {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.updateDraft.path
        : `/Template/${channelId}`;

      const response = await HttpAxios[
        axiosSelectedWhatsapp.updateDraft.bffName
      ][axiosSelectedWhatsapp.updateDraft.method](URI, payload);

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getDefaultWhatsAppTemplates(
    phoneId: string,
    campaignType: string
  ): Promise<IDefaultTemplateWhatsapp[]> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.bemaxTemplatesDefault.path[campaignType]
        : `/Template/${phoneId}/campaign-templates-default?campaignType=${campaignType}`;

      const response = await HttpAxios[
        axiosSelectedWhatsapp.bemaxTemplatesDefault.bffName
      ][axiosSelectedWhatsapp.bemaxTemplatesDefault.method](URI);

      return response.data.response.templates;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getAutomaticRepliesCampaign(): Promise<
    IConversationConfiguredWhatsapp[]
  > {
    try {
      const response = await HttpAxios[
        axiosSelectedWhatsapp.bemaxCampaign.bffName
      ][axiosSelectedWhatsapp.bemaxCampaign.method](
        axiosSelectedWhatsapp.bemaxCampaign.path
      );

      return response.data.response.conversationConfigurations;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async saveAutomaticRepliesCampaign(payload): Promise<any> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.create.path
        : "/ConversationConfigurations/create-update";

      const response = await HttpAxios[axiosSelectedWhatsapp.create.bffName][
        axiosSelectedWhatsapp.create.method
      ](URI, { ...payload });

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getPunctualWhatsappCampaigns(
    begin: string,
    end: string,
    storyState: string
  ): Promise<ICampaignPunctualList[]> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.sents.path
        : `/Campaign/manual?begin=${begin}&end=${end}&storyState=${storyState}`;

      const response = await HttpAxios[axiosSelectedWhatsapp.sents.bffName][
        axiosSelectedWhatsapp.sents.method
      ](URI);

      return response.data.response.campaings;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getPunctualScheduledWhatsappCampaign(
    storyState: string
  ): Promise<ICampaignPunctualList[]> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.scheduled.path
        : `/Campaign/manual?storyState=${storyState}`;

      const response = await HttpAxios[axiosSelectedWhatsapp.scheduled.bffName][
        axiosSelectedWhatsapp.scheduled.method
      ](URI);

      return response.data.response.campaings;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getPunctualDraftWhatsappCampaign(
    begin: string,
    end: string,
    storyState: string
  ): Promise<ICampaignPunctualList[]> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.drafts.path
        : `/Campaign/manual?begin=${begin}&end=${end}&storyState=${storyState}`;

      const response = await HttpAxios[axiosSelectedWhatsapp.drafts.bffName][
        axiosSelectedWhatsapp.drafts.method
      ](URI);

      return response.data.response.campaings;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async deletePunctualScheduledWhatsappCampaign(
    id: string
  ): Promise<ICampaignPunctualList[]> {
    try {
      const response = await HttpAxios.bffSysops.delete(`/campaign/${id}`);

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getPunctualWhatsappCampaign(
    id: string,
    phoneId: string
  ): Promise<IEditCampaignPunctual> {
    try {
      const response = await HttpAxios.bffSysops.get(
        `/Campaign/${id}?phoneId=${phoneId}`
      );

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async editPunctualScheduledWhatsappCampaign(
    id: string
  ): Promise<ICampaignPunctualList[]> {
    try {
      const response = await HttpAxios.bffSysops.put(`/campaign/${id}`);

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async updatePunctualDraftWhatsappCampaign(
    storyId: string,
    payload
  ): Promise<ICampaignPunctual> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.updateDraft.path
        : `/campaign/${storyId}`;

      const response = await HttpAxios[
        axiosSelectedWhatsapp.updateDraft.bffName
      ][axiosSelectedWhatsapp.updateDraft.method](URI, { ...payload });

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getPunctualWhatsappTemplates(
    phoneId: string,
    campaignType: string
  ): Promise<ITemplatePunctual[]> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.defaultPontual.path
        : `/Template/${phoneId}/campaign-templates-default?campaignType=${campaignType}`;

      const response = await HttpAxios[
        axiosSelectedWhatsapp.defaultPontual.bffName
      ][axiosSelectedWhatsapp.defaultPontual.method](URI);

      return response.data.response.templates;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async createPunctualWhatsappCampaign(payload): Promise<ICampaignPunctual> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.create.path
        : "/campaign/create-manual";

      const response = await HttpAxios[axiosSelectedWhatsapp.create.bffName][
        axiosSelectedWhatsapp.create.method
      ](URI, { ...payload });

      return response.data.success;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async createPunctualDraftWhatsappCampaign(
    payload
  ): Promise<ICampaignPunctual> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.create.path
        : "/campaign/create-manual";

      const response = await HttpAxios[axiosSelectedWhatsapp.create.bffName][
        axiosSelectedWhatsapp.create.method
      ](URI, { ...payload });

      return response.data.success;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async sendTestPunctualWhatsappCampaign(
    payload
  ): Promise<ITestCampaignPunctual> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.create.path
        : "/campaign/send-test";

      const response = await HttpAxios[axiosSelectedWhatsapp.create.bffName][
        axiosSelectedWhatsapp.create.method
      ](URI, { ...payload });

      return response.data.success;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getWhatsappPunctualAudience(
    status: string,
    audience: string
  ): Promise<IAudiencePunctual[]> {
    try {
      const response = await HttpAxios.bffC.get(
        `/CustomAudience/audience/contact-by-phone?status=${status}&audiences=${audience}`
      );

      return response.data.response.audiences;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getDetailsWhatsappPunctualCampaign(
    storyId: string
  ): Promise<IDetailsPunctualCampaign> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.details.path
        : `/Campaign/events/${storyId}`;

      const response = await HttpAxios[axiosSelectedWhatsapp.details.bffName][
        axiosSelectedWhatsapp.details.method
      ](URI);

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getWorkflow(): Promise<IWorkflow[]> {
    try {
      const response = await HttpAxios.bffMailSender.get(
        "/workflow/campaign/workflows-campaigns"
      );

      return response.data.result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async createWhatsappTemplateStudio(
    payload
  ): Promise<ITemplateWhatsappStudio> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.create.path
        : "/template/custom";

      const response = await HttpAxios[axiosSelectedWhatsapp.create.bffName][
        axiosSelectedWhatsapp.create.method
      ](URI, { ...payload });

      return response.data.success;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getWhatsappListTemplateStudio(
    onlyApproved: boolean,
    begin: string,
    end: string
  ): Promise<ITemplateListWhatsappStudio[]> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.studio.path
        : `/template/custom?onlyApproved=${onlyApproved}&begin=${begin}&end=${end}`;

      const response = await HttpAxios[axiosSelectedWhatsapp.studio.bffName][
        axiosSelectedWhatsapp.studio.method
      ](URI);

      return response.data.response.templates;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getWhatsappAllTemplateStudioBemax(
    onlyApproved: boolean
  ): Promise<ITemplateListWhatsappStudio[]> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.bemaxTemplatesPersonalized.path
        : `/template/custom?onlyApproved=${onlyApproved}`;

      const response = await HttpAxios[axiosSelectedWhatsapp.sents.bffName][
        axiosSelectedWhatsapp.sents.method
      ](URI);

      return response.data.response.templates;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getWhatsappAllTemplateStudio(
    onlyApproved: boolean
  ): Promise<ITemplateListWhatsappStudio[]> {
    try {
      const URI = activeMock
        ? axiosSelectedWhatsapp.personalizedPontual.path
        : `/template/custom?onlyApproved=${onlyApproved}`;

      const response = await HttpAxios[
        axiosSelectedWhatsapp.personalizedPontual.bffName
      ][axiosSelectedWhatsapp.personalizedPontual.method](URI);

      return response.data.response.templates;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getWhatsappTemplateStudio(
    templateId: string
  ): Promise<ITemplateListWhatsappStudio> {
    try {
      const response = await HttpAxios.bffSysops.get(
        `/template/custom/${templateId}`
      );

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async editWhatsappTemplateStudio(
    templateId: string,
    payload
  ): Promise<ITemplateListWhatsappStudio> {
    try {
      const response = await HttpAxios.bffSysops.put(
        `/template/custom/${templateId}`,
        payload
      );

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async renameWhatsappTemplateStudio(
    templateId: string,
    alias
  ): Promise<string> {
    try {
      const response = await HttpAxios.bffSysops.patch(
        `/template/custom/${templateId}/rename`,
        alias
      );

      return response.data.response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * @description busca de variaveis para inserção em campos de texto
   * @returns array de strings
   */
  async getAudienceVariables(): Promise<any> {
    try {
      const response = await HttpAxios.mock("/campaigns/variables.json");

      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * @description busca as tags de preview e optout configuradas pelo cliente
   * @return {Promise<ITags>}
   */
  async getTagsPreviewOptout(): Promise<ITags> {
    try {
      const response = await HttpAxios.bffMailSender.get("/config/email/tags");

      return response.data.result[0];
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * @description atualizar tags de preview e optout
   * @param {ITags} tags - objeto com novo valor das tags
   * @returns valida o status da request para exibir modal de sucesso ou erro
   */
  async updateTagsPreviewOptout(payload: ITags): Promise<ITags> {
    try {
      const response = await HttpAxios.bffMailSender.put(
        "/config/email/tags",
        payload
      );

      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default new Campaigns();
